<script setup>
const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: 'toggle',
  },
  icon: {
    required: true,
  },
  toggle: {
    type: Boolean,
    default: false,
  },

})

const modelValue = defineModel()

const emit = defineEmits(['click'])
</script>

<template>
  <button
    v-if="type === 'toggle'"
    v-tooltip="label"
    type="button"
    class="p-1"
    :class="toggle ? (modelValue ? 'bg-indigo-500 text-white': 'text-gray-800') : ''"
    @click.prevent="modelValue = !modelValue">
    <component :is="icon" class="w-4 h-4" />
  </button>
  <button
    v-else-if="type === 'button'"
    v-tooltip="label"
    type="button"
    class="p-1"
    @click="emit('click')">
    <component :is="icon" class="w-4 h-4" />
  </button>
</template>
